
import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { ApplicationService } from './application.service';

@Injectable({
  providedIn: 'root'
})
export class SignalrService {

  connection: signalR.HubConnection;

  constructor(public applicationService: ApplicationService) {
   
  }


}
